module.exports = __webpack_public_path__ + "img/card-corner-h5.09476011.svg";